<template>
  <!-- <Table border :columns="columns" :data="data"></Table> -->
   <div style="width: 100%;text-align:center;font-size: 30px;">欢迎登录后台管理系统

    <div style="width: 100%;text-align:center;font-size: 30px;">当前用户:{{ username}}</div>
   </div>


</template>

<script>
import { getUsername } from "../utils/token";

export default {
  name: "JsonTree",
  data() {
    return {
      username:"",
      columns: [
        {
          title: "Name",
          key: "name",
          render: (h, params) => {
            return h("div", [
              h("Icon", {
                props: {
                  type: "ios-person",
                },
              }),
              h("strong", params.row.name),
            ]);
          },
        },
        {
          title: "Age",
          key: "age",
        },
        {
          title: "Address",
          key: "address",
        },
        {
          title: "Action",
          key: "action",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.show(params.index);
                    },
                  },
                },
                "View"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.remove(params.index);
                    },
                  },
                },
                "Delete"
              ),
            ]);
          },
        },
      ],
      data: [
        {
          name: "John Brown",
          age: 18,
          address: "New York No. 1 Lake Park",
        },
        {
          name: "Jim Green",
          age: 24,
          address: "London No. 1 Lake Park",
        },
        {
          name: "Joe Black",
          age: 30,
          address: "Sydney No. 1 Lake Park",
        },
        {
          name: "Jon Snow",
          age: 26,
          address: "Ottawa No. 2 Lake Park",
        },
      ],
    };
  },
  mounted(){
    this.username = getUsername()
  },
  methods: {
    show(index) {
      this.username = getUsername();
      this.$Modal.info({
        title: "User Info",
        content: `Name: ${this.data[index].name}<br>Age: ${this.data[index].age}<br>Address: ${this.data[index].address}`,
      });
    },
    remove(index) {
      this.data.splice(index, 1);
    },
  },
};
</script>
